import { SpacingComponents } from './spacing-components';
import { SpacingConst } from './spacing-const';

export const Spacing = {
    ...SpacingConst,
    ...SpacingComponents
};
